import * as types from './mutation-types'

/**
 * @param commit
 * @param FormUuid
 * @return Promise
 */
export const formSetForm = ({commit}, FormUuid) => {
  return new Promise((resolve) => {
    Vue2.prototype.$api.active().get('forms/' + FormUuid, {
      params: {
        include: 'fields,folder',
      },
    }).then(({data}) => {
      commit(types.FORM_SET_FORM, data)
      resolve('Form loaded')
    })
  })
}

/**
 * @param commit
 * @return Promise
 */
export const formSetEditableMembershipForms = ({commit}) => {
  return new Promise((resolve, reject) => {
    Vue2.prototype.$api.active().get(`forms`, {
      params: {scope: 'membership', per_page: 10000},
    }).then(({data}) => {
      commit(types.FORM_SET_EDITABLE_MEMBERSHIP_FORMS, data.data)
      resolve(data)
    })
  })
}

/**
 * @param commit
 * @return Promise
 */
export const formSetHiddenMembershipForms = ({commit}) => {
  return new Promise((resolve, reject) => {
    Vue2.prototype.$api.active().get(`forms`, {
      params: {scope: 'membership', include: 'hiddenFields', per_page: 10000},
    }).then(({data}) => {
      commit(types.FORM_SET_HIDDEN_MEMBERSHIP_FORMS, data.data)
      resolve(data)
    })
  })
}

/**
 * @param commit
 * @return Promise
 */
export const formGetForms = ({ commit }, ) => {
  return new Promise((resolve) => {
    Vue2.prototype.$api.active().get(`forms`, {
      params: {},
    }).then(({data}) => {
      commit(types.FORM_SET_FORMS, data)
      resolve(data)
    })
  })
}

/**
 * @param commit
 * @param options
 * @return Promise
 */
export const formGetSubmissions = ({ commit }, options) => {
  return new Promise((resolve) => {
    Vue2.prototype.$api.active().get(`forms/${options.formUuid}/submissions`, {
      params: {per_page: options.per_page, page: options.page},
    })
      .then(({data}) => {
        commit(types.FORM_SET_FORM_SUBMISSIONS, data)
        resolve(data)
      })
  })
}

/**
 * @param commit
 * @param state
 */
export const formSelectAllFormSubmissions = ({commit, state}) => {
  return new Promise((resolve) => {
    Vue2.prototype.$api.active().get(`forms/${state.form.form.uuid}/submissions`, {
      params: {per_page: 10000000, page: 1},
    })
      .then(({data}) => {
        commit(types.FORM_SELECT_ALL_FORM_SUBMISSIONS, data.data)
        resolve(data)
      })
  })
}


/**
 * @param commit
 * @param state
 * @param dispatch
 * @param payload
 * @return Promise
 */
export const formDownloadSelectedFormSubmissions = ({ commit, state, dispatch }, payload) => {
  return new Promise((resolve, reject) => {
    commit('formStartExportingSubmissions')

    const format = payload.parameters.format
    const config = formGetExportConfigObject(format)

    Vue2.prototype.$api.active().post(`forms/${state.form.form.uuid}/submissions/export`, payload.parameters, config).then(({ data }) => {
      dispatch(formGetSubmissionExportDispatchMethod(format), {
        data,
        reportName: `${_.kebabCase(state.form.form.attributes.title)}-export-${new Date().toDateString()}`,
      })

      resolve(data)
    }).catch((errors) => {
      commit('baseAddNotification', {
        type: 'error',
        text: 'There was an error exporting submissions.',
        timeout: false,
      })

      commit('formStopExportingSubmissions')

      reject(errors)
    })
  })
}

/**
 * @param format
 */
export const formGetExportConfigObject = (format) => {
  let config = {}

  if (format === 'pdf') {
    config =  {
      responseType: 'arraybuffer',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/pdf',
      },
    }
  }

  return config
}

/**
 * @param format
 */
export const formGetSubmissionExportDispatchMethod = (format) => {
  return format === 'pdf'
    ? 'formDownloadSubmissionExportPDF'
    : 'formDownloadSubmissionExportCSV'
}

/**
 * @param commit
 * @param payload
 */
export const formDownloadSubmissionExportCSV = ({ commit }, payload) => {
  let url = window.URL || window.webkitURL
  const blob = new Blob([payload.data], {type: 'text/csv;charset=utf-8;'})
  const hrefObject = url.createObjectURL(blob)

  formDownloadSubmissionExportFileAs('csv', commit, payload, hrefObject)

  commit('formStopExportingSubmissions')
}

/**
 * @param commit
 * @param payload
 */
export const formDownloadSubmissionExportPDF = ({ commit }, payload) => {
  let url = window.URL || window.webkitURL
  const blob = new Blob([payload.data], {type: 'application/pdf'})
  const hrefObject = url.createObjectURL(blob)

  formDownloadSubmissionExportFileAs('pdf', commit, payload, hrefObject)

  commit('formStopExportingSubmissions')
}

/**
 * @param fileExtension
 * @param commit
 * @param payload
 * @param hrefObject
 */
export const formDownloadSubmissionExportFileAs = (fileExtension, commit, payload, hrefObject) => {
  let link = document.createElement('a')
  link.setAttribute('href', hrefObject)
  link.setAttribute(
    'download',
    Vue2.prototype.$slugify.transform(`${payload.reportName} ${new Date().toLocaleDateString()}`) + `.${fileExtension}`
  )
  link.click()

  commit('formStopExportingSubmissions')
}
